import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import CreateStockCost from './create'

import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import FilterListIcon from '@mui/icons-material/FilterList'
import FilterListOffIcon from '@mui/icons-material/FilterListOff'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from '@mui/material/CircularProgress'

const StockCostToolbar = (props) => {
  const { selected, add, remove, clean, edit, vendor, } = props

  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const deleteConfirmation = () => setDeleteDialog(true)
  const confirmDelete = () => remove(selected.id) || setDeleteDialog(false)
  const closeDelete = () => setDeleteDialog(false)

  const [cleanDialog, setCleanDialog] = React.useState(false)
  const cleanConfirmation = () => setCleanDialog(true)
  const confirmClean = () => clean() || setCleanDialog(false)
  const closeClean = () => setCleanDialog(false)

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Envíos a almacén
        <Dialog onClose={closeDelete} open={deleteDialog}>
          <DialogTitle>Eliminar</DialogTitle>
          <Button onClick={confirmDelete}>Ok</Button>
        </Dialog>
        <Dialog onClose={closeClean} open={cleanDialog}>
          <DialogTitle>Limpiar</DialogTitle>
          <Button onClick={confirmClean}>Ok</Button>
        </Dialog>
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title="Editar">
            <IconButton onClick={() => edit(selected.id)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton onClick={deleteConfirmation}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }

      <Tooltip title="Añadir costo de envío">
        <IconButton onClick={add} disabled={!vendor}>
          <AddIcon />
          {!vendor && "Seleccione un canal de venta"}
        </IconButton>
      </Tooltip>


      <Tooltip title="Limpiar costos pasados">
        <IconButton onClick={cleanConfirmation}>
          <DeleteSweepIcon />
        </IconButton>
        
      </Tooltip>
    </Toolbar>
  )
}

const StockCost = () => {
  const { vendor, } = React.useContext(AppContext)
  const SalesChannel = React.useContext(SalesChannelsContext)  
  const { current } = SalesChannel
	const { stockCosts, clean, remove, detail } = SalesChannel.stockCosts
  const [open, setOpen] = React.useState(false)
  const openD = (s) => {
    setOpen(true)
  }
  return (
    <Stack>
      <StockCostToolbar vendor={vendor} selected={current} add={openD} edit={openD} remove={remove} clean={clean}/>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell alignt="left">Fecha</TableCell>
              <TableCell alignt="left">Cliente</TableCell>
              <TableCell alignt="left">Costo</TableCell>
  						<TableCell alignt="left">Código</TableCell>
              <TableCell alignt="left">Método</TableCell>
              <TableCell alignt="left">Descripción</TableCell>
              <TableCell alignt="left">Canal de venta</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!stockCosts && <CircularProgress size={27}/>}
            {stockCosts && stockCosts.map((stockCost) => (
              <TableRow
                selected={current && current.id ==stockCost.id?true:false}
                onClick={() => current && current.id == stockCost.id?detail(false):detail(stockCost)}
                key={stockCost.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align="left">{stockCost.date?new Date(stockCost.date).toISOString().split('T')[0]:'-'}</TableCell>
                <TableCell align="left">{stockCost.client.name}</TableCell>
                <TableCell align="left">{stockCost.cost}</TableCell>
                <TableCell align="left">{stockCost.guide}</TableCell>
                <TableCell align="left">{stockCost.method}</TableCell>
                <TableCell align="left">{stockCost.description}</TableCell>
                <TableCell align="left">{stockCost.vendor}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CreateStockCost model={current} open={open} close={() => setOpen(false)}/>
    </Stack>
  )
}
export default StockCost